import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var FlagIcon = function FlagIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "FlagIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.11 1.344C3.614 1.16 4.36 1 5.413 1c1.117 0 2.043.337 2.83.624l.04.014c.82.299 1.499.538 2.302.538.885 0 1.434-.134 1.736-.244a1.7 1.7 0 0 0 .318-.15.83.83 0 0 1 .866-.124c.3.132.494.427.494.754V9.47a.82.82 0 0 1-.27.607v.001l-.001.001-.002.002-.004.003-.009.008a1 1 0 0 1-.075.06q-.064.05-.167.113c-.138.083-.328.18-.581.272-.506.184-1.25.344-2.305.344-1.117 0-2.043-.337-2.83-.623l-.04-.015c-.82-.299-1.499-.538-2.302-.538-.885 0-1.434.134-1.736.244l-.023.008v4.219c0 .454-.37.823-.827.823A.826.826 0 0 1 2 14.177V2.412c0-.231.098-.452.27-.608l.001-.002.002-.001.004-.004.009-.008.075-.06q.064-.05.167-.112c.138-.084.329-.18.581-.273M3.654 2.9l.023-.008c.302-.11.85-.244 1.736-.244.803 0 1.481.24 2.302.538l.04.015c.787.286 1.713.624 2.83.624a7.7 7.7 0 0 0 1.759-.183v5.342l-.023.008c-.302.11-.85.244-1.736.244-.803 0-1.481-.24-2.302-.538l-.04-.014c-.787-.287-1.713-.624-2.83-.624a7.7 7.7 0 0 0-1.759.183z",
      clipRule: "evenodd"
    })
  }));
};

export { FlagIcon };
